/**
 * SWC: keep product-gallery dots in sync with currently visible slides.
 * When variant filtering (alt-text match or fallback) hides some product
 * media, the corresponding pagination dots are hidden too, so the dot
 * count and order match what the swipe actually navigates.
 *
 * Generic — works whether Savor hides slides via [hidden], aria-hidden,
 * inline style, or class. Watches the gallery via MutationObserver.
 */
(function () {
  function isHidden(el) {
    if (!el) return true;
    if (el.hidden || el.hasAttribute('hidden')) return true;
    if (el.getAttribute('aria-hidden') === 'true') return true;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return true;
    return false;
  }

  function syncDots(gallery) {
    if (!gallery) return;
    var slides = gallery.querySelectorAll('slideshow-slide');
    if (!slides.length) return;
    var dotsList = gallery.querySelector('.slideshow-controls__dots');
    if (!dotsList) return;
    var dots = dotsList.children;
    if (!dots.length) return;
    var visibleCount = 0;
    var n = Math.min(slides.length, dots.length);
    for (var i = 0; i < n; i++) {
      var hidden = isHidden(slides[i]);
      dots[i].style.display = hidden ? 'none' : '';
      if (!hidden) visibleCount++;
    }
    // If everything would be hidden (no alt-text matches at all),
    // fall back to showing every dot so the carousel stays usable.
    if (visibleCount === 0) {
      for (var j = 0; j < dots.length; j++) {
        dots[j].style.display = '';
      }
    }
  }

  function init(gallery) {
    if (!gallery || gallery.dataset.swcDotsSync === '1') return;
    gallery.dataset.swcDotsSync = '1';
    syncDots(gallery);
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncDots(gallery);
      });
    });
    observer.observe(gallery, {
      attributes: true,
      subtree: true,
      attributeFilter: ['hidden', 'aria-hidden', 'style', 'class']
    });
  }

  function boot() {
    var galleries = document.querySelectorAll('media-gallery, slideshow-component');
    galleries.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
